import { ZipManagerV1Impl } from './v1';
export * from './v1/types';
export const defineZipManager = () => ({
    id: 'zip-manager',
    create: () => {
        const srv = new ZipManagerV1Impl();
        return {
            '1.2.1': () => ({
                featureService: srv
            })
        };
    }
});
